// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"158":"071f958c","298":"2a132fb2","604":"6bcbc384"}[chunkId] + ".css";
};